export default "__VITE_ASSET__95e7f223__"